// DePaul University's undergraduate majors (#2839). Read on 2026-10-01 from
// the official 2026-2027 Academic Catalog's program list
// (catalog.depaul.edu/programs), keeping every undergraduate program the
// catalog tags as a bachelor's degree, under the college or school it names.
// Folded into their major: the Honors versions (Accountancy, Economics,
// Finance, Marketing Honors) and the online versions of on-campus majors.
// The two Mathematics and Computer Science (BS) programs keep one entry in
// each college that offers them. Left out: minors, certificates, combined
// bachelor's + master's programs, BSN Completion (the RN to MSN path for registered
// nurses with an associate degree in nursing) and graduate programs.
const majors = {
    "slug": "depaul-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in DePaul's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Honors versions and online versions are folded into their major; minors, certificates, combined bachelor's and master's programs, the BSN Completion program for registered nurses and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Social Sciences",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, College of Liberal Arts and Social Sciences",
                "url": "https://catalog.depaul.edu/colleges-schools/liberal-arts-social-sciences/"
            },
            "majors": [
                {
                    "name": "African and Black Diaspora Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Diplomacy",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art, Media, and Design",
                    "degree": "BA"
                },
                {
                    "name": "Art, Media, and Design",
                    "degree": "BFA"
                },
                {
                    "name": "Catholic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science + Economics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Geography",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + History",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Writing and Rhetoric",
                    "degree": "BS"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Islamic World Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latino/a Culture and Communication",
                    "degree": "BA"
                },
                {
                    "name": "Peace, Justice and Conflict Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Writing and Rhetoric",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Science and Health",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, College of Science and Health",
                "url": "https://catalog.depaul.edu/colleges-schools/science-health/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Psychology + Economics",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Driehaus College of Business",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, Driehaus College of Business",
                "url": "https://catalog.depaul.edu/colleges-schools/business/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BSB"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BSB"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSB"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSB"
                },
                {
                    "name": "Economic Data Analytics",
                    "degree": "BSB"
                },
                {
                    "name": "Economics",
                    "degree": "BSB"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSB"
                },
                {
                    "name": "Finance",
                    "degree": "BSB"
                },
                {
                    "name": "Hospitality Leadership",
                    "degree": "BSB"
                },
                {
                    "name": "Management",
                    "degree": "BSB"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BSB"
                },
                {
                    "name": "Marketing",
                    "degree": "BSB"
                },
                {
                    "name": "Real Estate",
                    "degree": "BSB"
                },
                {
                    "name": "Sports Business",
                    "degree": "BSB"
                }
            ]
        },
        {
            "name": "College of Communication",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, College of Communication",
                "url": "https://catalog.depaul.edu/colleges-schools/communication/"
            },
            "majors": [
                {
                    "name": "Communication and Media",
                    "degree": "BA"
                },
                {
                    "name": "Digital Communication",
                    "degree": "BA"
                },
                {
                    "name": "Human Communication",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media and Popular Culture",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Communication",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations and Advertising",
                    "degree": "BA"
                },
                {
                    "name": "Sports Communication",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Jarvis College of Computing and Digital Media",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, Jarvis College of Computing and Digital Media",
                "url": "https://catalog.depaul.edu/colleges-schools/computing-digital-media/"
            },
            "majors": [
                {
                    "name": "Animation",
                    "degree": "BA"
                },
                {
                    "name": "Animation",
                    "degree": "BFA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Animation",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Film & Television",
                    "degree": "BA"
                },
                {
                    "name": "Film & Television",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design",
                    "degree": "BS"
                },
                {
                    "name": "Game Programming",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BFA"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Intelligent Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Network Engineering and Security",
                    "degree": "BS"
                },
                {
                    "name": "Robotics",
                    "degree": "BS"
                },
                {
                    "name": "User Experience Design",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, College of Education",
                "url": "https://catalog.depaul.edu/colleges-schools/education/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BSPE"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA/BS"
                },
                {
                    "name": "Secondary Education Biology",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education English",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education History",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education Physics",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education Social Science",
                    "degree": "BA"
                },
                {
                    "name": "Special Education",
                    "degree": "BS"
                },
                {
                    "name": "Visual Art Education",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education Chinese",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education French",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education German",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education Italian",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education Japanese",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Music",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, School of Music",
                "url": "https://catalog.depaul.edu/colleges-schools/music/"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": "BM"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music Performance",
                    "degree": "BM"
                },
                {
                    "name": "Performing Arts Management",
                    "degree": "BM"
                },
                {
                    "name": "Performing Arts Management",
                    "degree": "BS"
                },
                {
                    "name": "Sound Recording Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "The Theatre School",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, The Theatre School",
                "url": "https://catalog.depaul.edu/colleges-schools/theatre/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Comedy Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Costume Design",
                    "degree": "BFA"
                },
                {
                    "name": "Costume Technology",
                    "degree": "BFA"
                },
                {
                    "name": "Dramaturgy/Criticism",
                    "degree": "BFA"
                },
                {
                    "name": "Lighting Design",
                    "degree": "BFA"
                },
                {
                    "name": "Playwriting",
                    "degree": "BFA"
                },
                {
                    "name": "Projection Design",
                    "degree": "BFA"
                },
                {
                    "name": "Scene Design",
                    "degree": "BFA"
                },
                {
                    "name": "Sound Design",
                    "degree": "BFA"
                },
                {
                    "name": "Stage Management",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Directing & Creative Producing",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Management",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Technology",
                    "degree": "BFA"
                },
                {
                    "name": "Wig and Makeup",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "School of Continuing and Professional Studies",
            "source": {
                "label": "DePaul 2026-2027 Academic Catalog, School of Continuing and Professional Studies",
                "url": "https://catalog.depaul.edu/colleges-schools/continuing-professional-studies/"
            },
            "majors": [
                {
                    "name": "Applied Behavioral Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BAPS"
                },
                {
                    "name": "Computing",
                    "degree": "BAPS"
                },
                {
                    "name": "Decision Analytics",
                    "degree": "BA"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BA"
                },
                {
                    "name": "Leadership Studies",
                    "degree": "BA"
                },
                {
                    "name": "Nonprofit Management",
                    "degree": "BA"
                },
                {
                    "name": "Recreation and Sport Management",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
